import { COLORS, Label } from "shared/ui-basics/index";
import { Popover, Row } from "react-bootstrap";
import { FormFeedback } from "reactstrap";
import styled from "styled-components/macro";


export const FormFeedbackWrapper = styled(FormFeedback)`

    display:${(props) => props.display === "true" ? 'block' : 'none'};
    color: #605F60;
    .svg{
        color:red;
    }

`

export const PopoverCustom = styled(Popover)`
            width: max-content;
            left: auto !important;
            border-radius: 4px;
            background: #fff;
            box-shadow: -2px -2px 4px 0px rgba(0, 0, 0, 0.25), 2px 2px 4px 0px rgba(0, 0, 0, 0.25);
            `;
export const TableWrapper = styled.div`
/* border-radius: 4px; 
overflow: hidden; 
border: 1px solid #ccc;  */
`;
export const StyledTable = styled.table`
/* border-radius: 4px; */
/* border: 1px solid #D9D9D9 ; */
background: #F8FAFC;
width: 100%;
border-collapse: collapse; /* Ensures table borders render correctly */
thead tr:first-child th:first-child {
    border-top-left-radius: 4px; /* Top-left corner */
  }

  thead tr:first-child th:last-child {
    border-top-right-radius: 4px; /* Top-right corner */
  }

  tbody tr:last-child td:first-child {
    border-bottom-left-radius: 4px; /* Bottom-left corner */
  }

  tbody tr:last-child td:last-child {
    border-bottom-right-radius: 4px; /* Bottom-right corner */
  }
`;
export const ThWrapper = styled.th`
            padding:0.5rem;
            border:1px solid #D9D9D9;
            
            /* border-bottom:1px solid #D9D9D9; */
            text-wrap:nowrap;
            ${props => props?.iscenter && `text-align:center`}

            `
export const TdWrapper = styled.td`
            padding:4px 0.5rem;
            /* border:1px solid #c4c4c4; */

            border:1px solid #D9D9D9;
            font-size:14px;
            ${props => props?.iscenter && `text-align:center;`}
            /* border-bottom:1px solid #D9D9D9; */
            `

export const InputWrapper = styled.input`
            border:none;
            width: 100%;
            height:28px;
            padding-left:0.25rem;
            padding-right:0.25rem;
            background:transparent;

            ${props => props?.isitalic && `font-style:italic;`}
            &:hover{
                cursor:pointer;
            }
            &:focus  {
                ${(props) => !props?.disabled &&
                `border: 1px solid #C4C4C4; 
                 border-radius: 4px;
                 background:#fff;`}
			        }
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
          `

export const QueryBuilderDiv = styled.div`
/* .queryBuilder-branches .ruleGroup{
    border-color: #D9D9D9;
} */
    .react-select__menu {
  max-width: 200px; /* Adjust to your desired width */
  overflow-wrap: break-word;
  white-space: normal;
}

/* Optionally limit the width of individual options */
.react-select__option {
  max-width: 200px; /* Same as the menu width for consistency */
  overflow-wrap: break-word;
  white-space: normal;
}
    .custom-field-class {
    max-width: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
.queryBuilder .btn.ruleGroup-addRule {
    color: #262626 !important;
    background-color: #F8FAFC !important;
    border: 0px;
    margin-right:0.5rem;
       &:hover, &:focus  {
				color: #262626 !important;
				background-color: #F8FAFC  !important;
				border: 1px solid #262626   !important;
			}
}
.queryBuilder .btn.ruleGroup-addGroup  {
    color: #262626 !important;
    background-color: #F8FAFC !important;
    border: 0px;

       &:hover, &:focus  {
				color: #262626 !important;
				background-color: #F8FAFC  !important;
				border: 1px solid #262626   !important;
			}
}
.ruleGroup-combinators.form-select{
     &:focus
     {
            border-color:#ced4da!important;
            box-shadow: none  !important;
     }      
}
.ruleGroup {
    background:transparent;
    border-color: #D9D9D9;
}
.ruleGroup-body .ruleGroup{
    background:#F1F5F9;
}
.btn-danger{
    background-color: transparent !important;
	color: ${COLORS.label} !important;
	border: 1px solid ${COLORS.lightHover} !important;
        &:hover, &:focus {
				color: ${COLORS.label} !important;
				background-color: ${COLORS.lightHover} !important;
				border: 1px solid ${COLORS.lightHover} !important;
			}
}
`
export const WrapperButton = styled.div`
/* .deleteButton {
    visibility: hidden;
} */
`
export const TrWrapper = styled.tr`
            background-color: #ffffff !important;

:hover {
    .deleteButton{
		visibility: visible;
    }
}
${(props) => props.disabled && `background:#F8FAFC!important;`}
`

export const LabelCenter = styled(Label)`
text-align:center;
`

export const DivSurveyWrapper = styled.div`
border-radius: 4px;
border: 1px solid  #D9D9D9;
background:#F8FAFC ;
`
export const DivSurveyLabel = styled.div`
    border-bottom:1px solid #D9D9D9;
    margin: 0.5rem;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem
`